import '.hy{border-bottom:1px solid var(--brand-secondary);}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.hz{padding:1.5rem 0;}.ssr-plugin'
import '.b4{border:none;}.ssr-plugin'
import '.c9{background:transparent;}.ssr-plugin'
import '.z{cursor:pointer;}.ssr-plugin'
import '.ft{text-align:left;}.ssr-plugin'
import '.ag{flex-shrink:0;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.a9{justify-content:center;}.ssr-plugin'
import '.ec{width:1.5rem;}.ssr-plugin'
import '.i0{font-size:1.25rem;}.ssr-plugin'
import '.dg{font-weight:700;}.ssr-plugin'
import '.i1{padding-bottom:1.125rem;}.ssr-plugin'
import { useId, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons'
import { Text } from '@app/components/core/typography/Text'
import { type Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'

export type FaqItemProps = {
  question: string
  answer: string
  style?: Style
}

export const FaqItem = ({ question, answer, style }: FaqItemProps) => {
  const baseId = useId()
  const panelId = `${baseId}-panel`
  const triggerId = `${baseId}-trigger`
  const [open, setOpen] = useState(false)

  return (
    <styled.div className="hy"
      style={{
        ...style,
      }}
    >
      <button className="d n hz b4 c9 z ft"
        type="button"
        id={triggerId}
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((v) => !v)}
      >
        <Title.H3
          style={{
            flex: 1,
            margin: 0,
          }}
        >
          {question}
        </Title.H3>
        <span className="ag d r a9 ec i0 dg"
          aria-hidden
        >
          <FontAwesomeIcon icon={open ? faMinus : faPlus} />
        </span>
      </button>
      {open ? (
        <div className="i1"
          id={panelId}
          role="region"
          aria-labelledby={triggerId}
        >
          <Text.Medium
            style={{
              margin: 0,
              color: 'var(--brand-secondary)',
              opacity: 0.85,
              lineHeight: '1.45',
              fontWeight: 400,
            }}
          >
            {answer}
          </Text.Medium>
        </div>
      ) : null}
    </styled.div>
  )
}
